import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getMaintainers = async () => {
	const { data } = await axios.get(`${API}/admin/maintainers`);
	return data;
};

export const getSettings = async () => {
	const { data } = await axios.get(`${API}/admin/settings`);
	return data;
};
